// src/components/common/SEO.jsx
import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({ title, description, canonical }) => {
  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {canonical && <link rel="canonical" href={canonical} />}
    </Helmet>
  );
};

export default SEO;
